export const SMALL_LOSS_LIMIT_USD = 0.01;
export const SMALL_LOSS_LIMIT_PERCENT = 0.01;
export const HUGE_LOSS_LIMIT_PERCENT = 2;
